export const SMALLEST_UNIT_DIVISOR = 100_000_000;

export type UsdRatesMap = Record<string, number>;

export const formatUsd = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const formatCryptoAmount = (
  amount: number | string | null | undefined
): string => {
  if (amount === null || amount === undefined) return '0';
  const value = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(value)) return '0';
  return (value / SMALLEST_UNIT_DIVISOR).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });
};

const normalizeCurrency = (currency: string): string => currency.trim().toUpperCase();

export const getUsdRate = (
  currency: string,
  rates: UsdRatesMap
): number | null => {
  const cur = normalizeCurrency(currency);
  if (cur === 'USD' || cur === 'USDT') return 1;
  const rate = rates[cur];
  return rate != null && Number.isFinite(rate) ? rate : null;
};

export const unitsToUsd = (
  units: number,
  currency: string,
  rates: UsdRatesMap
): number | null => {
  if (!Number.isFinite(units)) return null;
  const rate = getUsdRate(currency, rates);
  if (rate === null) return null;
  return Math.round((units / SMALLEST_UNIT_DIVISOR) * rate * 100) / 100;
};

export const decimalToUsd = (
  amount: number,
  currency: string,
  rates: UsdRatesMap
): number | null => {
  if (!Number.isFinite(amount)) return null;
  const rate = getUsdRate(currency, rates);
  if (rate === null) return null;
  return Math.round(amount * rate * 100) / 100;
};

export const buildRatesMap = (
  rows: Array<{ currency: string; average: number | string | null }>
): UsdRatesMap => {
  const map: UsdRatesMap = {};
  for (const row of rows) {
    const average = row.average != null ? Number(row.average) : null;
    if (average != null && Number.isFinite(average)) {
      map[normalizeCurrency(row.currency)] = average;
    }
  }
  return map;
};
